const getUserIdentity = () => {
  let userId = '';
  try {
    userId = JSON.parse(localStorage.getItem('userDetails') || '{}')?.user_id || '';
  } catch {
    userId = '';
  }

  return userId || localStorage.getItem('token') || 'visitor';
};

export const getServicesIntroDismissedKey = () => `docity_services_intro_dismissed:${getUserIdentity()}`;

export const getOnboardingDemoDismissedKey = () => `docity_onboarding_demo_dismissed:${getUserIdentity()}`;

export const hasOnboardingDemoBeenDismissed = () =>
  localStorage.getItem(getOnboardingDemoDismissedKey()) === 'true';
